import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mapIcon from '../../../../images/icons/map.svg';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ReactModal from 'react-modal';
import ReactHtmlParser from 'react-html-parser';
import { SetComponentLanguage } from '../../../../helpers';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDetailsOpen: false,
            isCastOpen: false
        };
    }

    toggle = () => {
        this.setState({
            isDetailsOpen: !this.state.isDetailsOpen
        }, () => {
            if (this.props.isInStreamPage) {
                if (!this.state.isDetailsOpen) {
                    this.props.hideStreamDescriptionModal();
                }
            } else {
                this.props.toggleDetails(this.props.event.id);
            }
        });
    }

    toggleCast = () => {
        this.setState({
            isCastOpen: !this.state.isCastOpen
        });
    }
    
    componentWillReceiveProps(props) {
        this.setState({
			isDetailsOpen: props.event.isDetailsOpen === true || props.isStreamDescriptionModalOpen === true
        });
    }

    render() {
        return (
            <div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.state.isDetailsOpen}
                    role={
                        "dialog"
                    }
                >
                    <button className="showtix-modal__close" onClick={this.toggle} aria-label="Close the Event Details modal">&times;</button>
                    <div className="showtix-event__details">
                        <div className="showtix-event__details__poster">
                            { this.props.event.poster_graphic_url ?
                                <img src={this.props.event.poster_graphic_url} alt="" />
                            :
                                (this.props.event.type === "flexpass" ?
                                    <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} alt="" />
                                :
                                    <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} alt="" />
                                )
                            }
                            {!this.props.event.poster_graphic_url &&
                                <div className="showtix-event__poster__title">
                                    {ReactHtmlParser(this.props.event.name)}
                                </div>
                            }
                        </div>
                        <div className="showtix-event__details__content">
                            <span className="showtix-event__details__content__pretitle">{strings.presentedBy} {ReactHtmlParser(this.props.client_name)}</span>
                            <h4 className="showtix-event__details__content__title">{ReactHtmlParser(this.props.event.name)}</h4>
                            <div className="showtix-event__details__content__description">
                                {ReactHtmlParser(this.props.event.desc)}
                            </div>
                            <div className="row">
                                <div className="col-12 showtix-event__details__content__info">
                                    <div className="showtix-event__details__content__info__icon">
                                        <img src={mapIcon} alt="" />
                                    </div>    
                                    <div className="showtix-event__details__content__info__content">
                                        <p>
                                        {this.props.event.venue && (
                                            <React.Fragment>
                                                <strong>{this.props.event.venue.name}</strong>
                                                <br />
                                                {ReactHtmlParser(this.props.event.venue.address + "<br />" + this.props.event.venue.city + ", " + this.props.event.venue.state + "<br />" + this.props.event.venue.zip)}
                                                <br />
                                                <a target="_blank" rel="noopener" href={"https://maps.google.com/?q=" + this.props.event.venue.address + "+" + this.props.event.venue.city + "+" + this.props.event.venue.state + "+" + this.props.event.venue.zip}>{strings.getDirections}</a><br /><br />
                                            </React.Fragment>
                                        )}
                                        {this.props.event.contact_phone}<br />
                                        {this.props.event.event_website !== '' && (
                                            <React.Fragment>
                                                <a target="_blank" rel="noopener" href={"http://" + this.props.event.event_website}>{this.props.event.event_website}</a><br />
                                            </React.Fragment>
                                        )}
                                        { this.props.event.playbilder_url !== null &&
                                            <React.Fragment>
                                                <a className="showtix-button showtix-button__small showtix-background__primary-2" target="_blank" rel="noopener" href={this.props.event.playbilder_url}>Show Program</a><br />
                                            </React.Fragment>     
                                        }
                                        <a href={"mailto:" + this.props.event.contact_email}>{this.props.event.contact_email}</a></p>
                                        {this.props.event.service_fee === 'customer' &&
                                            <p className="showtix-note"><em>{strings.priceNote}</em></p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.event.artists.length > 0 &&
                        <div className="row">
                            <div className="col-12">
                                <div className="showtix-event__cast">
                                    <div className={"showtix-event__cast__mask" + (this.state.isCastOpen ? ' is-active' : '')}>
                                        <div className="row">
                                            {this.props.event.artists.map((artist, i) => 
                                                <div
                                                    key={i}
                                                    className="col-12 col-sm-6 col-md-4 text-center">
                                                    <p><strong>{artist.position}</strong><br />{ReactHtmlParser(artist.first_name)} {ReactHtmlParser(artist.last_name)}</p>
                                                </div>    
                                            )}
                                        </div>
                                    </div> 
                                    <button 
                                        className="showtix-event__cast__button"
                                        onClick={this.toggleCast}
                                    >
                                        { this.state.isCastOpen ?
                                            strings.showLess
                                        :
                                            strings.showMore
                                        }
                                    </button>   
                                </div>    
                            </div>
                        </div> 
                    }
                    {this.props.event.ad_graphic_url && 
                        <div className="row">
                            <div className="col-12 showtix-event__advertisement">
                                <img src={this.props.event.ad_graphic_url} alt="Advertisement" />
                            </div>
                        </div> 
                    }
                 </ReactModal>                    
            </div>
        );
    }
}

EventDetails.propTypes = {
    event: PropTypes.shape({
        id: PropTypes.number,
        status: PropTypes.string,
        poster_graphic_url: PropTypes.string,
        name: PropTypes.string,
        type: PropTypes.string,
        client_name: PropTypes.string,
        desc: PropTypes.string,
        location: PropTypes.string,
        contact_email: PropTypes.string,
        ad_graphic_url: PropTypes.string,
        contact_phone: PropTypes.string,
        pricing_options: PropTypes.array,
        artists: PropTypes.array
    }),
    toggleDetails: PropTypes.func,
    isInStreamPage: PropTypes.bool,
}

export default EventDetails;



// WEBPACK FOOTER //
// ./src/components/EventListing/Event/EventDetails/EventDetails.js